module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-xs-c5925e0f56fb70bc16349ff1701fccf3.png";